import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { getCategoryCourses } from "./../../actions/courseActions";
import { getCourseSubjects } from "./../../actions/subjectActions";
import Loader from "../Loader";
import "./course.css";

const CategoryCourses = ({ history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();
  const [courseId, setCourseId] = useState("");
  const [examDetails, setExamDetails] = useState({
    examId: "",
    examSlug: "",
    categoryId: "",
    examName: "",
    logo: "",
  });

  const { courses, cloading } = useSelector((state) => state.categoryCourses);
  const { courseSubjects } = useSelector((state) => state.courseSubjects);

  useEffect(() => {
    const examId = localStorage.getItem("examId");
    const examSlug = localStorage.getItem("examSlug");
    const categoryId = localStorage.getItem("categoryId");
    const examName = localStorage.getItem("examName");
    const logo = localStorage.getItem("logo");
    const savedCourseId = localStorage.getItem("courseId");

    setExamDetails({ examId, examSlug, categoryId, examName, logo });
    setCourseId(savedCourseId || "");

    if (categoryId) {
      dispatch(getCategoryCourses(categoryId));
    }
    window.scrollTo(0, 0);
  }, [dispatch]);

  const handleCourseChange = (e, item) => {
    setCourseId(e.target.value);
    localStorage.setItem("courseId", e.target.value);

    if (examDetails.examSlug === "post-utme") {
      dispatch(getCourseSubjects(e.target.value));
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!courseId) {
      alert.error("Please select a course type to proceed.");
      return;
    }

    localStorage.setItem("courseId", courseId);

    // Keep the Post-UTME course subject catalog for the picker UI, but do not
    // pre-write every subject id into "subjects" — that used to auto-register
    // them after payment without the student choosing.
    if (examDetails.examSlug === "post-utme" && courseSubjects) {
      localStorage.setItem("utmeSubjects", JSON.stringify(courseSubjects));
      localStorage.removeItem("subjects");
      localStorage.removeItem("processedSubjects");
    }

    history.push("/course-subjects");
  };

  return (
    <Fragment>
      <section
        className="page-banner-sec text-center"
        style={{
          backgroundImage: `url("../assets/frontend/img/about-banner.jpg")`,
        }}
      >
        <div className="container">
          <ul className="clearfix paginations-cust">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/categories">Intended Courses Types</Link>
            </li>
          </ul>
          <h1>Course of Study</h1>
        </div>
      </section>

      <section className="subscription-page">
        <div className="container">
          <div className="end-plan">
            <h1>Select intended course of study at university</h1>
          </div>
          <div className="custom-radios-plan course-spaner">
            {cloading ? (
              <Loader />
            ) : (
              <div className="wrapper clearfix">
                {courses?.map((item, key) => (
                  <Fragment key={item._id || key}>
                    <input
                      type="radio"
                      name="select"
                      value={item._id}
                      checked={item._id === courseId}
                      id={`option-${key + 1}`}
                      onChange={(e) => handleCourseChange(e, item)}
                    />
                    <label
                      htmlFor={`option-${key + 1}`}
                      className={`option option-${key + 1}${
                        item._id === courseId ? " checked" : ""
                      }`}
                      id={`option-${key + 1}-label`}
                    >
                      <div className="dot" />
                      <span>{item.title}</span>
                    </label>
                  </Fragment>
                ))}
              </div>
            )}
          </div>
          <div className="next-prev-steps text-center">
            <Link to="/categories" className="chose-more">
              <i className="fas fa-arrow-left" /> Prev
            </Link>{" "}
            <button type="submit" className="chose-more" onClick={submitHandler}>
              Next <i className="fas fa-arrow-right" />
            </button>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default CategoryCourses;
